// extracted by mini-css-extract-plugin
export default {"hamburger":"styles_hamburger__szbd8"};